import LINKTREE from '../enums/Linktree.js';

const nameMap = {
  [LINKTREE.INSTAGRAM]: "Meu instagram",
  [LINKTREE.TWITTER]: "Meu Twitter",
  [LINKTREE.FACEBOOK]: "Meu Facebook",
  [LINKTREE.WHATSAPP]: "Meu whatsapp",
  [LINKTREE.YOUTUBE]: "Meu Youtube",
  [LINKTREE.TIKTOK]: "Meu TiktoK",
  [LINKTREE.EMAIL]: "Meu Email",
  [LINKTREE.VIDEO]: "Meu Video",
  [LINKTREE.ECOMMERCE]: "Meu Ecommerce",
  [LINKTREE.ANDROID]: "Meu App Android",
  [LINKTREE.IOS]: "Meu App iOS",
  [LINKTREE.MAPS]: "Minha Localização"
};

export function setNameReport(type) {
  return nameMap[type] || null;
}
